export var DrivePadType;
(function (DrivePadType) {
    DrivePadType["DOC"] = "drive-doc";
    DrivePadType["SHEET"] = "drive-sheet";
    DrivePadType["TEXT"] = "drive-text";
    DrivePadType["SLIDE"] = "drive-slide";
    DrivePadType["PDF"] = "drive-pdf";
    DrivePadType["UNKNOWN"] = "drive-unknown";
})(DrivePadType || (DrivePadType = {}));
